import React, { Fragment } from "react";
import ProtoTypes from "prop-types";

import { Box, makeStyles, Paper, Typography } from "@material-ui/core";
import CountUp from "react-countup";
import { Skeleton } from "@material-ui/lab";

const DashboardCounter = ({ icon: Icon, number, title, color }) => {
  const useStyles = makeStyles((theme) => ({
    paper: {
      padding: 10,
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "column",
      alignItems: "end",

      margin: 20,
    },
    box: {
      padding: 20,
      background: theme.palette[color].main,
      color: theme.palette[color].contrastText,
      maxWidth: 100,
      textAlign: "center",
      borderRadius: 10,
      boxShadow: "1px 2px 3px 0px",
    },
    text: {
      textAlign: "end",
      width: "100%",
    },
  }));

  const classes = useStyles();

  return (
    <Fragment>
      {number ? (
        <Paper className={classes.paper}>
          <Box mt={-5} className={classes.box}>
            <Icon />
          </Box>
          <Typography className={classes.text} variant="h4">
            <CountUp start={0} end={number} duration={1} separator="," />
          </Typography>
          <Typography className={classes.text} variant="h6">
            Total {title}
          </Typography>
        </Paper>
      ) : (
        <Paper className={classes.paper}>
          <Box mt={-5} className={classes.box}>
            <Icon />
          </Box>
          <Typography className={classes.text} variant="h4">
            <CountUp start={0} end={0} duration={2.5} separator="," />
          </Typography>
          <Typography className={classes.text} variant="h6">
            Total {title}
          </Typography>
        </Paper>

        // <Skeleton style={{ margin: 20 }} height={200} />
      )}
    </Fragment>
  );
};

DashboardCounter.protoTypes = {
  icon: ProtoTypes.object.isRequired,
  number: ProtoTypes.number,
  title: ProtoTypes.string.isRequired,
  color: ProtoTypes.string,
};

export default React.memo(DashboardCounter);
